import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/ve2ventures.webp';
import screenshot_target from '../../../images/letterfunnel/daviddwinger.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="David Dwinger"
      firstname="David"
      companyname="ve2.ventures"
      competition="Builders.studio en leAD Sports"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/daviddwinger.js